import React from 'react';

import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';

// IF (07/02/20): Pulled from material-ui documentation
// https://material-ui.com/components/dialogs/#AlertDialogSlide.tsx

export const TransitionSlideUp = React.forwardRef(
  (
    props: TransitionProps & { children?: React.ReactElement<any, any> },
    ref: React.Ref<unknown>,
  ) => <Slide direction="up" ref={ref} {...props} />,
);
